<template>
  <div style="background: #f5f5f5 !important">
    <div class="title-section" style="display: flex">
      <h1 class="title title-ruban">MOT DE PASSE OUBLIÉ</h1>
    </div>
    <div class="page-seperate"></div>
    <div class="columns is-mobile is-centered">
      <div class="column is-one-quarter">
        <div class="has-text-right" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'login' }"> Déjà inscrit?</router-link>
        </div>
        <div class="has-text-right" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'register' }"
            >Nouvel utilisateur?</router-link
          >
        </div>
        <p v-if="!isSent" class="pt-3">
          Merci de renseigner votre adresse de messagerie. Vous recevrez un
          e-mail contenant les instructions vous permettant de réinitialiser
          votre mot de passe.
        </p>

        <p v-if="this.status != null" class="has-text-danger">
          Identifiant ou mot de passe incorrect
        </p>
        <form @submit.prevent="sendmail" v-if="!isSent" class="pt-3">
          <b-field label="Votre Adresse email de connexion" required>
            <b-input type="email" v-model="email" ref="email" required />
          </b-field>

          <b-button
            native-type="submit"
            name="button "
            style="
              margin-left: 50%;
              margin-right: 0%;
              margin-top: 1rem;
              margin-bottom: 0.5rem;
            "
            :loading="isLoading"
            class="is-primary"
          >
            Envoyer
          </b-button>
        </form>

        <p v-if="isSent">
          Les informations de connexion vous ont été transmises par email.

          <b-button
            native-type="submit"
            tag="router-link"
            :to="{ name: 'route-name' }"
            name="button "
            style="
              margin-left: 50%;
              margin-right: 0%;
              margin-top: 1rem;
              margin-bottom: 0.5rem;
            "
            class="is-primary"
          >
            Ecran de Connexion
          </b-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
export default {
  name: "LostPassword",
  data() {
    return {
      email: "",
      isSent: false,
      isLoading: false,
      status: null,
    };
  },
  methods: {
    sendmail() {
      this.isLoading = true;

      const auth = getAuth();
      auth.languageCode = "fr";
      sendPasswordResetEmail(auth, this.email)
        .then(() => {
          this.isSent = true;
          this.isLoading = false;
        })
        .catch((err) => {
          this.status = err.response.status;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
